<template>
  <div id="wizard">
    <div class="wizard-header">
      <v-container>
        <v-overlay opacity="0.40" :absolute="true" :value="isLoading" :z-index="3">
          <v-progress-circular
            indeterminate
            color="primary"
            :size="60"
            :width="5"
            class="mr-10px"
          />
          {{ loadingMessage }}
        </v-overlay>
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: true,
      loadingMessage: 'Prebieha načítanie dát, prosím počkajte ...',
    };
  },
  async mounted() {
    try {
      await this.$store.dispatch('fillCacheFromExternalForm');
    } finally {
      this.isLoading = false;
    }
  },
};
</script>
